<ng-container *ngIf="!rowNode['group']">
    <div class="detail-cell-wrapper" [ngClass]="{'expanded': isCellExpanded}" (click)="toggleOnWholeCell ? toggleDetailGrid() : ''"
            [style.cursor]="toggleOnWholeCell ? 'pointer' : 'unset'" >
        <span class="ag-cell-wrapper ag-cell-expandable ag-row-group px-0-pxl">
            <span class="ag-group-value" data-ref="eValue">{{ params?.valueFormatted || params?.value }}</span>

            <span class="toggler" (click)="!toggleOnWholeCell ? toggleDetailGrid() : ''">
                <span class="ag-group-expanded" [ngClass]="{'ag-hidden': !isCellExpanded}" data-ref="eExpanded">
                    <span class="ag-icon ag-icon-tree-open" role="presentation"></span>
                </span>
                <span class="ag-group-contracted" [ngClass]="{'ag-hidden': isCellExpanded}" data-ref="eContracted">
                    <span class="ag-icon ag-icon-tree-closed" role="presentation"></span>
                </span>
            </span>
        </span>
    </div>
</ng-container>

